import { Helmet } from 'react-helmet-async';
import { useHistory, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import TabsMAIQ from 'app/components/TabsMAIQ';
import { PageHeader } from 'app/components/StyledComponents';
import { BreadcrumbsComponent } from 'app/components/BreadcrumbsComponent';
import DealerSettingsTab from './components/dealerSettings/DealerSettingsTab';
import ValueContentTab from './components/valueContent/ValueContentTab';
import OfferContentTab from './components/offerContent/OfferContentTab';
import FooterImageTab from './components/footerImage/FooterImageTab';
import DealerSpecialsTab from './components/dealerSpecials/DealerSpecialsTab';
import MessageContentTab from './components/messageContent/MessageContentTab';
import ContentImportExport from './components/ContentImportExport';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasResource } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';

const TAB_SLUGS = [
  'dealer-settings',
  'value-content',
  'offer-content',
  'footer-image',
  'dealer-specials',
  'message-content',
];

const ContentManagementPage = () => {
  const selectedDealer = useSelector(selectDealerSelected) || {};
  const selectedDealerId = selectedDealer.dealer || '';
  const hasImportExportAccess = hasResource('ImportExportMAIQ');

  const history = useHistory();
  const location = useLocation();

  const activeTab = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const slug = params.get('tab');
    const index = TAB_SLUGS.indexOf(slug || '');
    return index >= 0 ? index : 0;
  }, [location.search]);

  const handleTabChange = useCallback(
    (index: number) => {
      const params = new URLSearchParams(location.search);
      params.set('tab', TAB_SLUGS[index]);
      history.replace({ search: params.toString() });
    },
    [history, location.search],
  );

  const tabsData = [
    { label: 'DEALER SETTINGS',  content: <DealerSettingsTab /> },
    { label: 'VALUE CONTENT',    content: <ValueContentTab /> },
    { label: 'OFFER CONTENT',    content: <OfferContentTab /> },
    { label: 'FOOTER IMAGE',     content: <FooterImageTab /> },
    { label: 'DEALER SPECIALS',  content: <DealerSpecialsTab /> },
    { label: 'MESSAGE CONTENT',  content: <MessageContentTab /> },
  ];

  const breadcrumbsList = [{ label: 'Content Management', isActive: true }];

  return (
    <>
      <Helmet>
        <title>Content Management</title>
        <meta
          name="description"
          content="Manage Content Engine Settings, Offers, Dealer Values, and Branding Information"
        />
      </Helmet>
      <Box sx={{
        height: 'calc(100vh - 66px)',
        padding: '0 48px',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Box sx={{ marginTop: '48px', marginBottom: '48px', display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
            <PageHeader sx={{ marginBottom: '0 !important' }}>Content Management</PageHeader>
          </Box>
          {hasImportExportAccess && <ContentImportExport selectedDealerId={selectedDealerId} />}
        </Box>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <TabsMAIQ
            key={selectedDealerId}
            tabs={tabsData}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </Box>
      </Box>
    </>
  );
};

export default ContentManagementPage;
